import { useQuery } from '@tanstack/react-query';
import * as impactService from '../services/designImpactService';

export const impactKeys = {
  analysis: (projectId: string, issueId: string) => ['impactAnalysis', projectId, issueId] as const,
  traceability: (projectId: string, designItemId: string) => ['traceability', projectId, designItemId] as const,
};

export function useImpactAnalysis(projectId: string, issueId: string, enabled = false) {
  return useQuery({
    queryKey: impactKeys.analysis(projectId, issueId),
    queryFn: () => impactService.fetchImpactAnalysis(projectId, issueId),
    enabled: enabled && !!projectId && !!issueId,
  });
}

export function useTraceability(projectId: string, designItemId: string) {
  return useQuery({
    queryKey: impactKeys.traceability(projectId, designItemId),
    queryFn: () => impactService.fetchTraceability(projectId, designItemId),
    enabled: !!projectId && !!designItemId,
  });
}
